import { InfoCircleFill } from 'react-bootstrap-icons';
import { useParams } from 'react-router-dom';

import { Button } from 'antd';

import Alert from '@/components/shared/Alert';
import { useAppSelector } from '@/hooks/redux';
import { enStatus } from '@/interfaces/course';
import { loginAccounts } from '@/services/accounts';
import { coursesApi } from '@/services/course';
import { lessonsApi } from '@/services/lesson';
import styled, { StyledProp } from '@/styled';

const NotAuthenticated = ({ className }: StyledProp) => {
  const user = useAppSelector(state => state.auth.user);

  const { hash, id } = useParams();
  const { data: course } = coursesApi.endpoints.getCourse.useQueryState(hash);
  const { data: lesson } = lessonsApi.endpoints.getLessons.useQueryState(id);

  if (user || (course?.is_free && [enStatus.SOMETHING_FREE, enStatus.FREE].includes(lesson?.status))) {
    return null;
  }

  const login = () => {
    loginAccounts();
  };

  return (
    <Alert
      className={className}
      icon={<InfoCircleFill size={20} />}
      type='error'
      message={'Ops! Parece que você não está logado.'}
      description={'Clique no botão abaixo e faça o login.'}
      action={
        <Button type='primary' rootClassName='loginButton' size='large' onClick={login}>
          Logar
        </Button>
      }
    />
  );
};

export default styled(NotAuthenticated)`
  .loginButton {
    svg {
      color: ${({ theme }) => theme.colorIcon};
    }
  }
`;
